/* rxlib - Paginacao v2.0.0 */

import { Link } from 'react-router-dom';

interface PaginacaoProps {
    paginaAtual: number;
    linkListagem: string;
    queryString?: string;
    quantidadeTotal: number;
    quantidadePorPagina: number;
}

export function Paginacao(props: PaginacaoProps) {
    let paginas = [];
    let quantidadePaginas = Math.ceil(props.quantidadeTotal / props.quantidadePorPagina);

    const queryString = props.queryString ? props.queryString : '';

    function obterLinkPagina(pagina: number): string {
        return `${props.linkListagem}/pagina/${pagina}${queryString}`;
    }

    for (let contador = 0; contador < quantidadePaginas; contador++) {
        paginas.push({ pagina: contador + 1 });
    }

    let paginaAtual = props.paginaAtual ? props.paginaAtual : 1;

    return (
        quantidadePaginas > 1
            ? <nav aria-label='Paginação' key='paginacao'>
                <ul className='pagination justify-content-end'>
                    {
                        (paginaAtual - 1) > 0
                            ? <li key='anterior' className='page-item'>
                                <Link
                                    className='page-link'
                                    to={obterLinkPagina(paginaAtual - 1)}>
                                    Anterior
                                </Link>
                            </li>
                            : ''
                    }
                    {
                        paginas.map((item, index) =>
                            (item.pagina.toString() === paginaAtual.toString())
                                ? <li key={index} className='page-item active'>
                                    <Link
                                        className='page-link'
                                        to={obterLinkPagina(item.pagina)}>
                                        {item.pagina}
                                    </Link>
                                </li>
                                : <li key={index} className='page-item'>
                                    <Link
                                        className='page-link'
                                        to={obterLinkPagina(item.pagina)}>
                                        {item.pagina}
                                    </Link>
                                </li>
                        )
                    }
                    {
                        (paginaAtual + 1) <= quantidadePaginas
                            ? <li key='proximo' className='page-item'>
                                <Link
                                    className='page-link'
                                    to={obterLinkPagina(paginaAtual + 1)}>
                                    Próximo
                                </Link>
                            </li>
                            : ''
                    }
                </ul>
            </nav>
            : null
    );
}